export const portfolioDividendEfp = [
  {
    id: '12345',
    valueConverted: 24,
    monthYear: '2024-11-01', // YYYY-MM-DD
    holdingCount: 4,
    type: 'declared',
  },
  {
    id: '12345',
    valueConverted: 52,
    monthYear: '2024-10-02', // YYYY-MM-DD
    holdingCount: 4,
    type: 'declared',
  },
  {
    id: '12345',
    valueConverted: 123,
    monthYear: '2024-12-03', // YYYY-MM-DD
    holdingCount: 2,
    type: 'declared',
  },
  {
    id: '12345',
    valueConverted: 123,
    monthYear: '2024-12-03', // YYYY-MM-DD
    holdingCount: 3,
    type: 'estimated',
  },
  {
    id: '12345',
    valueConverted: 50,
    monthYear: '2025-01-01', // YYYY-MM-DD
    holdingCount: 5,
    type: 'estimated',
  },
  {
    id: '12345',
    valueConverted: 100,
    monthYear: '2025-02-01', // YYYY-MM-DD
    holdingCount: 6,
    type: 'estimated',
  },
];